import Typography from '@components/common/typography';
import styles from './styles.module.scss';
import { useTranslation } from 'react-i18next';
import InfoBlock from '@components/common/info_block';
import useModalContext from '@hooks/context/useModalContext';

const DeleteWalletContactModal = () => {
    const { t } = useTranslation('modals', {
        keyPrefix: 'delete_wallet_account'
    });
    const { modalData } = useModalContext();
    return (
        <div className={styles.wrapper}>
            <Typography className={styles.title} variant="h4">
                Delete contact
            </Typography>
            <div className={styles.description}>
                Are you sure you want to delete {modalData?.name}?
            </div>
            <InfoBlock variant="error">
                Please note: Any pending or scheduled payments you’ve set up for for this contact
                will be canceled. Remember to make other arrangements for future payments you may
                still owe.
            </InfoBlock>
        </div>
    );
};

export default DeleteWalletContactModal;
